import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "advertlaunch"
};
import { onMounted, ref } from "vue";
import AdvertLaunchList from './AdvertLaunchMonitorList';
import apis from "@/api";
import { ElMessage } from "element-plus";
export default {
  __name: 'Index',
  setup(__props) {
    const roleFlag = ref("");
    const roleId = ref("");
    const elLoading = ref(false);
    onMounted(() => {
      queryIsRoleWho();
    });

    /** 查询用户角色属于（0供应商 、1宣传管理员、2监测公司 3、合同管理员） */
    const queryIsRoleWho = () => {
      elLoading.value = true;
      apis.queryIsRoleWho().then(res => {
        if (res.success) {
          console.log("roleinfo", res.data);
          roleFlag.value = res.data.roleFlag;
          roleId.value = res.data.roleId;
        } else {
          // ElMessage.error(res.msg)
        }
      }).catch(err => {
        // ElMessage.error(err)
      }).finally(() => {
        elLoading.value = false;
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(AdvertLaunchList), {
        "role-flag": roleFlag.value,
        "role-id": roleId.value
      }, null, 8, ["role-flag", "role-id"])]);
    };
  }
};